import * as actionTypes from "../actions/actionTypes";

const initialState = null;

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SCENARIO_LOAD:
      return action.result;
    default:
      return state;
  }
};

export default reducer;
